import React from 'react';
import { CampaignDetailsRow } from '../campaign-details-row';

export function withSegmentation(WrappedComponent) {
  return class extends React.PureComponent {
    onRenderRowWithSegmentation = (props, level = 0, indent = 15) => (
      <React.Fragment>
        <CampaignDetailsRow
          className={level === 0 ? '' : 'segmentation-row'}
          {...props}
          item={props.item}
          columns={props.columns.map(this.processColumns(level * indent))}
          freezingColumnCount={props.freezingColumnCount}
          selectionMode={props.selectionMode}
        />
        {props.item.segmentedData && props.item.segmentedData.length > 0 &&
          props.item.segmentedData.map(item => this.onRenderRowWithSegmentation({ ...props, item }, level + 1))}
      </React.Fragment>
    );

    processColumns = textIndent => col => ({
      ...col,
      onRender: (item, index, column) => {
        const { onRender } = col;
        if (col.textIndentEnabled) {
          return (
            <div
              className="text-indent-cell"
              style={{ textIndent }}
            >
              {onRender(item, index, column)}
            </div>
          );
        }
        return onRender(item, index, column);
      },
    });

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onRenderRowWithSegmentation={this.onRenderRowWithSegmentation}
        />
      );
    }
  };
}
